import { breakpoints } from "@config/theme"
import styled from "styled-components"

export const Content = styled.div<{ isColorLight: boolean }>`
  color: ${(p) => (p.isColorLight ? "white" : p.theme.colors.text.dark)};
  text-decoration: none;

  span {
    display: block;
    margin-bottom: -0.5rem;
  }

  * {
    color: ${(p) => (p.isColorLight ? "white" : p.theme.colors.text.dark)};
  }
`
export const Anchor = styled.a<{
  alignTextTop: boolean
  backgroundUrl: string
}>`
  display: flex;
  align-items: ${(p) => (p.alignTextTop ? "flex-start" : "flex-end")};
  position: relative;
  background: ${(p) => p.theme.colors.card.default};
  background-image: url(${(p) => p.backgroundUrl});
  background-position: center center;
  background-size: cover;
  transition: background 0.1s ease-in-out;
  width: 100%;
  height: 100;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  padding: 1rem;

  @media screen and (min-width: ${breakpoints.medium}) {
    padding: 2rem;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      [data-link-button] span::after {
        width: 100%;
        opacity: 1;
      }
    }
  }
`
